import payment from './client';
const apiType = 'py';
const opts = {
    headers: {
        Accept: '*/*',
        'Content-Type': `application/json`,
    },
};
export const postApi = async (body, token, endpoint, logger) => {
    logger ? payment.setLogger(logger) : undefined;
    return payment.post(endpoint, apiType, {
        data: body,
        headers: { ...opts.headers, Authorization: `Bearer ${token}` },
    });
};
